const config = {
  CopyerObjMap: { 1: 'list', 2: 'list', 3: 'list', 4: 'bmDirector', 5: 'zsDirector' },
  CopyerChildObjMap: { 1: 'person', 2: 'department', 3: 'role' }
};
export { config };
